import type { CatalogoDescriptor } from '@next/compartilhados/catalogos'

export type OpcaoGrupoDeLocaisDeTrabalho = Readonly<{
  id: string
  name: string
  companies?: readonly Readonly<{ id: string, name?: string | null }>[] | null
  groups?: readonly Readonly<{ id: string, name?: string | null }>[] | null
}>

export type FiltrosCatalogoGrupoDeLocaisDeTrabalho = Readonly<{
  id?: readonly string[]
  companies?: readonly string[]
  groups?: readonly string[]
}>

export type SelecaoCatalogoGrupoDeLocaisDeTrabalho = OpcaoGrupoDeLocaisDeTrabalho | readonly OpcaoGrupoDeLocaisDeTrabalho[] | null
export type OperacoesCatalogoGrupoDeLocaisDeTrabalho = Readonly<{ listarOpcoes: (sinal: AbortSignal) => Promise<readonly OpcaoGrupoDeLocaisDeTrabalho[]> }>

const CAMPOS_PROJECAO = new Set(['id', 'name', 'companies', 'groups'])

const camposRelacoes = {"companies": ["id", "name"], "groups": ["id", "name"]}
const validarRelacao = (valor: unknown, campos: readonly string[]): boolean => {
  if (typeof valor !== 'object' || valor === null) return true
  if (Array.isArray(valor)) return valor.every(item => validarRelacao(item, campos))
  return Object.keys(valor).every(campo => campos.includes(campo))
}

export const DESCRITOR_CATALOGO_GRUPO_DE_LOCAIS_DE_TRABALHO: CatalogoDescriptor<OpcaoGrupoDeLocaisDeTrabalho> = Object.freeze({
  nome: 'grupos-de-locais-de-trabalho',
  versaoProjecao: 2,
  validarItens: (valor: unknown): valor is readonly OpcaoGrupoDeLocaisDeTrabalho[] => (
    Array.isArray(valor) && valor.every((item: unknown) => typeof item === 'object' && item !== null && !Array.isArray(item)
      && Object.keys(item).every(campo => CAMPOS_PROJECAO.has(campo))
      && Object.entries(camposRelacoes).every(([campo, permitidos]) => validarRelacao((item as Record<string, unknown>)[campo], permitidos)))
  ),
})
